import { render, staticRenderFns } from "./LoteEquipamentoEsterilizacao.vue?vue&type=template&id=0960bbb1&"
import script from "./LoteEquipamentoEsterilizacao.vue?vue&type=script&lang=js&"
export * from "./LoteEquipamentoEsterilizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports